/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 15.10.2016.
 */

import Footer from './footer';

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/Footer/index.js